'use client'

import sendToBothAnalytics from '@/lib/mixpanel/sendToBothAnalytics'
import { MIXPANEL_CLIENT_EVENT_NAMES } from '@/lib/mixpanel/constant'
import { useCurrentUser } from '@/hooks/use-current-user'
import { useEffect, useRef } from 'react'

interface PageTrackerProps {
  pageName: string
  eventName: keyof typeof MIXPANEL_CLIENT_EVENT_NAMES
  additionalProps?: Record<string, any>
}

export function PageTracker({
  pageName,
  eventName,
  additionalProps = {},
}: PageTrackerProps) {
  const { data: user, isLoading } = useCurrentUser()
  const hasTracked = useRef(false)

  useEffect(() => {
    // 防止重复发送
    if (isLoading || hasTracked.current) return

    hasTracked.current = true

    sendToBothAnalytics(
      MIXPANEL_CLIENT_EVENT_NAMES[eventName],
      {
        page: pageName,
        ...additionalProps,
      },
      user?._id?.toString(),
    )
  }, [user?._id, isLoading, pageName, eventName, additionalProps])

  return null
}
